import ButtonWithLoader from "@/common/components/ui/loading/ButtonLoading";
import { FormikProvider, useFormik } from "formik";

type FormPropsCancelNegativation = {
  onSubmit: (data: { reason: string }) => void;
  onClose: () => void;
  negativationId: string;
}

function FormCancelNegativation(props: FormPropsCancelNegativation) {

  const formik = useFormik({
    initialValues: {
      reason: ""
    },
    onSubmit: (values) => {
      props.onSubmit(values);
    }
  })

  return (
    <FormikProvider value={formik}>
      <form onSubmit={formik.handleSubmit}>
        <section>
          <label className="block mb-2 text-sm font-medium">
            Tem certeza que deseja cancelar a negativação?
          </label>
          <textarea
            name="reason"
            value={formik.values.reason}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            className="w-full h-24 border border-gray-300 rounded-md p-2"
            placeholder="Motivo do cancelamento"
            style={{ resize: "none" }}
          />

          {/* Footer customizado sem usar Modal.Footer */}
          <div className="p-6 border-t border-none-200">

            <div className="flex justify-between space-x-4">
              <button
                className="bg-none-2 text-none-800 rounded-md px-4 py-2 hover:bg-none-300 transition-colors"
                onClick={props.onClose}
              >
                Cancelar
              </button>
              <ButtonWithLoader
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2"
                onClick={formik.handleSubmit}
              >
                Confirmar
              </ButtonWithLoader>
            </div>
          </div>
        </section>
      </form>
    </FormikProvider>
  )
}

export default FormCancelNegativation;